// extracted by css-extract-rspack-plugin
export default {"composerScroll":"_H3SVIq9viIeMBzT"};